import {
	Button,
	ChildrenProps,
	ClassNameProps,
	Column,
	FormattedText,
	If,
	StyleProps,
	TruncatedText,
	TruncatedTextProps,
} from "@hex-insights/core";

export type ExpandableTextProps = Pick<TruncatedTextProps, "lines"> & {
	textClassName?: string;
} & Partial<ClassNameProps & StyleProps & ChildrenProps>;

export function ExpandableText({ lines, textClassName, className, style, children }: ExpandableTextProps) {
	const {
		isExpanded: isBodyExpanded,
		expand: expandBody,
		overflows: bodyOverflows,
		setOverflows: setBodyOverflows,
	} = TruncatedText.useTruncatedText();

	return (
		<Column justify="spaced-start" verticalSpacing="0.25rem" className={className} style={style}>
			<TruncatedText lines={lines} isExpanded={isBodyExpanded} setOverflows={setBodyOverflows}>
				<FormattedText className={textClassName}>{children}</FormattedText>
			</TruncatedText>

			<If condition={bodyOverflows && !isBodyExpanded}>
				<Button variant="link" size="small" onClick={expandBody}>
					Read More
				</Button>
			</If>
		</Column>
	);
}

export type TruncatedTextWithGeneralButtonProps = Pick<TruncatedTextProps, "lines"> & {
	onClick: () => void;
	textClassName?: string;
} & Partial<ClassNameProps & StyleProps & ChildrenProps>;

export function TruncatedTextWithGeneralButton({
	lines,
	onClick,
	textClassName,
	className,
	style,
	children,
}: TruncatedTextWithGeneralButtonProps) {
	const {
		isExpanded: isBodyExpanded,
		overflows: bodyOverflows,
		setOverflows: setBodyOverflows,
	} = TruncatedText.useTruncatedText();

	return (
		<Column justify="spaced-start" verticalSpacing="0.25rem" className={className} style={style}>
			<TruncatedText lines={lines} isExpanded={isBodyExpanded} setOverflows={setBodyOverflows}>
				<FormattedText className={textClassName}>{children}</FormattedText>
			</TruncatedText>

			<If condition={bodyOverflows && !isBodyExpanded}>
				<Button variant="link" size="small" onClick={onClick}>
					Read More
				</Button>
			</If>
		</Column>
	);
}
